<div class="cat__top-bar">
    <!-- left aligned items -->
    <div class="cat__top-bar__left" (clickOutside)="closeEventSwitch()">
        <!-- do not display the logo in the top bar -->
        <!--
        <div class="cat__menu-left__logo d-lg-inline-block d-none">
            <a [routerLink]="['/']">
                <div class="nav-logo"></div>
            </a>
        </div>
        -->

        <div *ngIf="fundraisingViewService.isManageEventsViewVisible()" class="event-selection-wrapper">
            <!-- Desktop -->
            <div class="d-none d-lg-flex d-xl-flex justify-content-between event-selection cursor-hand ui-event-selection-desktop"
                 (click)="openSwitchEvent()" *ngIf="eventService.selectedEvent">
                <h3 *ngIf="eventService.selectedEvent.programGroupName === 'MWOY'">
                    {{ eventService.selectedEvent?.label }} ({{eventService.selectedEvent?.programDescription}} campaign)
                </h3>
                <h3 *ngIf="eventService.selectedEvent.programGroupName !== 'MWOY'">
                    {{ eventService.selectedEvent?.label }} ({{eventService.selectedEvent?.programGroupDescription}} campaign)
                </h3>
                <a class="change-event-link text-primary" href="javascript:void(0)">
                    Switch Event
                    <i class="fa fa-angle-down"></i>
                </a>
            </div>
            <div class="backdrop" *ngIf="switchEvent" (click)="closeEventSwitch()"></div>

            <app-switch-event (onSwitchEventClose)="closeEventSwitch()" *ngIf="switchEvent"></app-switch-event>

            <!-- App -->
            <div class="d-sm-block d-lg-none d-xl-none event-selection cursor-hand ui-event-selection-mobile" (click)="openChangeEventModal()">
                <div class="dropdown" style="display:inline-block">
                    <span>{{ eventService.selectedEvent?.label }}</span>
                </div>
            </div>
        </div>

        <div *ngIf="fundraisingViewService.isManageNationalTeamsViewVisible()">
            <!-- Desktop -->
            <div class="d-none d-lg-flex d-xl-flex justify-content-between event-selection cursor-hand ui-event-selection-desktop"
                 (click)="openSwitchNationalTeam()" *ngIf="nationalTeamsService.selectedNationalTeam">
                <h3>
                    {{ nationalTeamsService.selectedNationalTeam?.name }} ({{nationalTeamsService.selectedNationalTeam?.programGroupDescription}} campaign)
                </h3>
                <a class="change-event-link text-primary" href="javascript:void(0)">
                    Switch Team
                    <i class="fa fa-angle-down"></i>
                </a>
            </div>
            <div class="backdrop" *ngIf="switchNationalTeam" (click)="closeNationalTeamSwitch()"></div>

            <app-switch-national-team (onSwitchNationalTeamClose)="closeNationalTeamSwitch()" *ngIf="switchNationalTeam"></app-switch-national-team>

            <!-- App -->
            <div class="d-sm-block d-lg-none d-xl-none event-selection cursor-hand ui-event-selection-mobile" (click)="openChangeNationalTeamModal()">
                <div class="dropdown" style="display:inline-block">
                    <span>{{ nationalTeamsService.selectedNationalTeam?.name }}</span>
                </div>
            </div>
        </div>

    </div>
    <!-- right aligned items -->
    <div class="cat__top-bar__right">
        <div class="cat__top-bar__item">
            <div class="row">
                <div class="col">
                    <div ngbDropdown [autoClose]="true" placement="bottom-right" class="dropdown cat__top-bar__avatar-dropdown">
                        <a href="javascript: void(0);" class="dropdown-toggle ui-topbar-dropdown" id="dropdownBasic0" ngbDropdownToggle aria-expanded="false">
                            <span
                                class="cat__top-bar__avatar mr-1"
                                href="javascript:void(0);"
                                [style.backgroundImage]="'url(' + avatar + ')'"
                            ></span>
                            <span class="d-none d-sm-inline-block">My Profile</span>
                        </a>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic0">
                            <a class="dropdown-item ui-topmenu-my-profile" routerLink="/profile">
                                <i class="dropdown-icon icmn-user"></i>
                                My Profile
                            </a>
                            <div class="dropdown-divider"></div>
                            <a id="logout" class="dropdown-item ui-topmenu-logout" href="javascript:void(0)" (click)="logout()">
                                <i class="dropdown-icon icmn-exit"></i>
                                Logout
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
